import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=446068bc&scoped=true&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=446068bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446068bc",
  null
  
)

export default component.exports